module.exports = "/images/weebly.png?fd35c7730adec72555f07a6694e9ebbd";